"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bss$CHANGE_CONTACT_DATA = '/info/change/contact-data';
exports.Bss$CHANGE_EINVOICE_CONSENT = '/info/change/eInvoice';
exports.Bss$CONSENTS = '/consents';
exports.Bss$CONSENTS_CHANGE = '/consents/change';
exports.Bss$INFO = '/info';
exports.Bss$LAST_SETTLEMENT = '/last-settlement';
exports.Bss$REPORT_SEND = '/report/send';
exports.Bss$SERVICES = '/services';
exports.Cms$ALL = '/all';
exports.Consultant$CONSULTANT_REGISTER = '/consultant/register';
exports.Consultant$REGISTER = '/register';
exports.Customer$CUSTOMER_API = '/cust-api';
exports.Dev$CLEAN = '/clean';
exports.Dev$CLEAR_CURRENT = '/clear/current';
exports.History$HISTORY = '/history';
exports.Messages$ATTACHMENT_IDENT_PATH_PARAM = '{attachmentIdent}';
exports.Messages$COUNT = '/count';
exports.Messages$DASHBOARD = '/dashboard';
exports.Messages$DELETE_BY_MESSAGE_IDENT = '/delete/{msgIdent}';
exports.Messages$DOWNLOAD_ATTACHMENT = '/attachment/{attachmentIdent}';
exports.Messages$MARK_AS_READ_BY_MESSAGE_IDENT = '/markRead/{msgIdent}';
exports.Messages$MESSAGE_IDENT_PATH_PARAM = '{msgIdent}';
exports.Operator$ARTICLE_BY_ARTICLE_NAME_AND_LANG = '/article/{articleName}/{lang}';
exports.Operator$ARTICLE_NAME_PATH_PARAM = '{articleName}';
exports.Operator$CONFIG = '/config';
exports.Operator$CONTACT = '/contact';
exports.Operator$LANG_PATH_PARAM = '{lang}';
exports.Operator$OPERAPI = '/oper-api';
exports.Payment$DOWNLOAD_INVOICE_BILLING_BY_INVOICE_UID = '/download/invoice-billing/{invoiceUid}';
exports.Payment$DOWNLOAD_INVOICE_BY_INVOICE_UID = '/download/invoice/{invoiceUid}';
exports.Payment$INVOICE_UID_PATH_PARAM = '{invoiceUid}';
exports.Payment$ORDER_INVOICE_BILLING_BY_INVOICE_UID = '/order/invoice-billing/{invoiceUid}';
exports.Payment$ORDER_INVOICE_BY_INVOICE_UID = '/order/invoice/{invoiceUid}';
exports.Payment$PAYMENTS_RANGE = '/payments/{range}';
exports.Payment$RANGE_PATH_PARAM = '{range}';
exports.Payment$SETTLEMENTS = '/settlements';
exports.Sec$SEC_API = '/sec-api';
exports.Settings$LOGIN = '/login';
exports.Theme$THEME = '/theme';
exports.User$USER = '/user';
exports.User$USER_CONTACT_TOKEN_GENERATE = '/user/contact/token/generate';
exports.User$USER_PASSWORD_CHANGE = '/user/password/change';
exports.User$USER_PASSWORD_FORGET = '/user/password/forget';
exports.User$USER_REGISTER = '/user/register';
